export default "__VITE_ASSET__D6drHUSA__$_?url__"